module.exports = __webpack_public_path__ + "static/img/setBackground1.f790ecc4.svg";